import { useStateContext } from '../../context';
import { Show } from 'solid-js';
import { EducationDescription } from '../EducationDescription/EducationDescription';
import { JobDescription } from '../JobDescription/JobDescription';
import { TravelDescription } from '../TravelDescription/TravelDescription';


export function InfoBox() {
    let state = useStateContext();
    return (
        <Show when={state.selectedEntity()}>
        <JobDescription />
        <EducationDescription />
        <TravelDescription />
        </Show>
    );
}
